import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { JSX } from 'react';

const Routes = (): JSX.Element => (
  <Switch>
    <ProtectedRoute isAllowed={false} showPermission exact path="/conversion" component={ConversionWIP} />
  </Switch>
);

const ConversionWIP = (): JSX.Element => {
  return <div>conversion</div>;
};

export default Routes;
